var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState, useMemo } from "react";
import { FilterWrapper, Table, TableCell, TableHeadlineCell, TableRow, TableWrapper } from "./PackageTable.styled";
import { Typography, Inputs, Grid } from "../../../components";

var PackageTable = function PackageTable(_a) {
  var packages = _a.packages,
      features = _a.features,
      filterTitle = _a.filterTitle,
      disclaimer = _a.disclaimer,
      filters = _a.filters,
      props = __rest(_a, ["packages", "features", "filterTitle", "disclaimer", "filters"]);

  var _b = useState(""),
      filter = _b[0],
      setFilter = _b[1];

  var filteredPackages = useMemo(function () {
    return packages.filter(function (_a) {
      var slug = _a.slug;

      if (filter === "") {
        return true;
      }

      return filter.includes(slug);
    });
  }, [filter, packages]);
  var options = useMemo(function () {
    if (filters) {
      return filters.map(function (_a) {
        var includes = _a.includes,
            label = _a.label;
        return {
          label: label,
          value: includes
        };
      });
    }

    return [];
  }, [filters]);
  return React.createElement(Grid.Container, __assign({}, props), filterTitle && React.createElement(FilterWrapper, {
    p: 4,
    justifyContent: "center",
    display: "flex",
    alignItems: "center"
  }, React.createElement(Typography, {
    m: 0,
    pr: 4
  }, filterTitle), React.createElement(Inputs.Select, {
    placeholder: "wybierz z listy",
    value: filter,
    onChange: function onChange(value) {
      return setFilter(value);
    },
    options: options
  })), React.createElement(TableWrapper, null, React.createElement(Table, null, filteredPackages.map(function (_a) {
    var label = _a.label,
        slug = _a.slug;
    return React.createElement(TableRow, null, React.createElement(TableHeadlineCell, {
      width: 30
    }, label), features[slug].map(function (_a) {
      var color = _a.color,
          label = _a.label;
      return React.createElement(TableCell, {
        color: color,
        isEmpty: label === "-",
        width: 70 / features[slug].length
      }, label);
    }));
  }))), disclaimer && React.createElement(Grid.Row, {
    mt: 3
  }, React.createElement(Grid.Col, {
    xs: 12,
    md: 7
  }, React.createElement(Typography, {
    variant: "small",
    color: "grey"
  }, disclaimer))));
};

export default PackageTable;